module.exports = __webpack_public_path__ + "static/media/submit_message.2d5642c1.svg";